import { render } from "./NotFound.vue?vue&type=template&id=a92497aa"
const script = {}

import exportComponent from "/media/alvian/New Volume/project/vue js/sample-inc-web-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__